// Display-only relabelling for participant-filter operators.
// The backend (insights/PM service) returns operator labels such as "In" / "Not In".
// We show "Is" / "Is not" in the UI without touching the underlying operator value,
// so filters already saved in the DB still resolve correctly when retrieved.
const OPERATOR_LABEL_MAP = {
  In: 'Is',
  'Not In': 'Is not',
}

export const displayOperatorLabel = label =>
  OPERATOR_LABEL_MAP[label] ?? label ?? ''
